<template>
  <!-- temporary
  :value="drawer"
  stateless
   -->
  <v-navigation-drawer
    :mini-variant.sync="drawer"
    mini-variant-width="70"
    permanent
    app
    id="mainnav"
    class="secondary"
  >
    <v-list class="white--text my-3">
      <v-list-item>
        <v-img v-if="!drawer" style="max-width: 120px;" src="/img/Dimitra Deforestation Compliance Logo White.png"/>
          <v-img v-if="drawer" width="10" height="30" contain src="/img/dimitra-white-alternate.png"/>
        <v-list-item-title v-if="drawer" class="text-h5 font-weight-bold white--text"
          >LG</v-list-item-title
        >
      </v-list-item>
    </v-list>

    <v-divider color="gray"></v-divider>
    <!-- <v-list nav dense v-for="(item, idx) in permissions" :key="idx"> -->
    <v-list nav dense v-for="(item, idx) in menuItems" :key="idx">
      <v-list-item
        :exact="item.exact"
        active-class="primary"
        class=""
        v-if="!item.submenus"
        :to="item.url"
        link
        @click="open = false"
      >
        <v-list-item-icon>
          <v-icon v-if="item.icon" class="white--text font-weight-bold">{{
            item.icon
          }}</v-icon>
          <img v-else :src="item.src" />
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="white--text font-weight-bold text-wrap">{{
            item.name
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group
        v-else
        :value="open"
        no-action
        class="white--text"
      >
        <template #prependIcon>
          <v-icon class="white--text" v-if="item.icon">{{ item.icon }}</v-icon>
          <img style="margin-left:-2px" v-else :src="item.src" />
        </template>
        <template v-slot:activator>
          <v-list-item-content style="margin-left:-22px">
            <v-list-item-title class="white--text font-weight-bold">{{
              item.name
            }}</v-list-item-title>
          </v-list-item-content>
        </template>
        <template #appendIcon>        
            <v-icon color="white">{{"mdi-chevron-down"}}</v-icon> 
        </template>
        

        <v-list-item
          v-for="(subitem, i) in item.submenus"
          :key="i"
          :to="subitem.url"
          link
          active-class="primary"
        >
          <v-list-item-icon>
            <v-icon class="white--text" v-if="subitem.icon">{{ subitem.icon }}</v-icon>
          <img style="height:10px; margin-top: 6px;" v-else :src="subitem.src" />
          </v-list-item-icon>
          <v-list-item-title
            style="margin-left: -16px"
            v-text="subitem.name"
            class="white--text"
          ></v-list-item-title>
        </v-list-item>
      </v-list-group>
    </v-list>

    <template v-slot:append>
      <div class="text-no-wrap text-caption text-center white--text mb-5">
        Version <br v-if="drawer" />
        1.0.0
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import isMobileMixin from "@/mixins/isMobileMixin";
export default {
  name: "sidebar",
  created() {},
  computed: {
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        return this.$store.commit("SET_DRAWER", !val);
      },
    },
    permissions() {
      return this.$store.getters.getUserPermissions(this.menuItems);
    },
  },
  methods: {
    setDrawer() {
      this.$store.commit("SET_DRAWER", !this.$store.state.drawer);
    },
  },
  watch: {
    "$store.state.drawer": function (value) {
      console.log(value, "value");
    },
  },
  data() {
    return {
      open: false,
      menuItems: [
        {
          id: 5,
          src: "/img/Farm.png",
          name: this.$t("registerFarm"),
          url: { name: "My farm" },
          exact: false,
        },
        {
          id: 21,
          src: "/img/ingredient-inventory.svg",
          name: this.$t("deforestationComplianceAssessment"),
          url: { name: "DeforestationList" },
        },
        // {
        //   id: 24,
        //   src: "/img/Details.png",
        //   name: "Deforestation Compliance Assessments",
        //   url: { name: "EUDRForestAssessments" },
        //   exact: false,
        // },
        // {
        //   id: 21,
        //   src: "/img/schedule.png",
        //   name: "Payment",
        //   url: { name: "Payment" },
        // },
        {
          id: 21,
          src: "/img/reports.png",
          name: this.$t('complianceCertificate'),
          url: { name: "Certificate" },
        }
      ],
    };
  },
  mixins: [isMobileMixin],
};
</script>

<style scoped>
::v-deep  .v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child {
    margin-right: 10px;
}

.v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child {
    margin-right: 10px;
}

.v-application--is-ltr .v-list--dense.v-list--nav .v-list-group--no-action > .v-list-group__items > .v-list-item {
    padding-left: 64px;
    margin-left: -50px;
}
.v-image__image{
  background-size: contain !important;
}
</style>